<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	
	<div class="d-flex align-items-center">
		<!-- <el-button type="success" size="mini" @click="openModel(false)">添加规格</el-button> -->
	
		<div class="mr-auto">
			<el-form inline ref="form" :model="searchform">
 <el-form-item class="mb-0 mr-0">
           <el-select v-model="admin_id" v-if="this.userid=='admin'"  style="width: 100px;" class="ml-2 mr-2" size="mini" @change="adminChange($event)">
               <el-option
                      v-for="item in adminlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
            </el-form-item>
					<el-form-item  class="mb-0">
						 <el-date-picker
						      v-model="searchform.time"
						      type="daterange"
						      range-separator="~"
						      :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd">
						    </el-date-picker>
					</el-form-item>
           <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px" ></el-input>
          </el-form-item>
         
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>	
					</el-form-item>
          
			</el-form>
       
		 
		
			
    		
		</div>
	
	</div>

  <el-table
      :data="tableData"
       v-loading="loading"
      style="width: 100%"
      border class="mt-2 calculation"  :empty-text="$t('tableText.데이타가없습니다')"
      show-summary
       :summary-method="getSummaries"
    >


       <el-table-column
        
        :label="$t('msg.아이디')" prop="mem_id" align="center">
         <template slot-scope="scope">
            
             <span @click="openCal(scope.row.mem_id,scope.row.type)" class="text-warning" style="cursor:pointer">{{scope.row.mem_id}} ({{scope.row.mem_name}})</span>
          </template>
      </el-table-column>

       <el-table-column
        
        :label="$t('tableText.타입')" prop="type" align="center">
        
      </el-table-column>
    
    <el-table-column
        
       :label="$t('msg.충전')" prop="tt1" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt1)}}</template>
      </el-table-column>
     
      <el-table-column
        
       :label="$t('msg.환전')" prop="tt2" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt2)}}</template>
      </el-table-column>

       <el-table-column
        
       :label="$t('msg.충환')" prop="tt1122" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt1122)}}</template>
      </el-table-column>


       <el-table-column 
       :label="$t('msg.총배팅')" prop="tt16" align="center">
         <template slot-scope="scope"> <span class="text-warning">{{ formatMoney(scope.row.tt16)}}</span></template>
      </el-table-column>

      <el-table-column 
        :label="$t('msg.총배팅카')" prop="tt12" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt12)}}</template>
      </el-table-column>
      <el-table-column 
      :label="$t('msg.총배팅슬')" prop="tt10" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt10)}}</template>
      </el-table-column>
      
     

        <el-table-column
       :label="$t('msg.총당첨')" prop="tt17" align="center">
         <template slot-scope="scope"> <span class="text-warning">{{ formatMoney(scope.row.tt17)}}</span></template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총당첨카')" prop="tt13" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt13)}}</template>
      </el-table-column>
      <el-table-column
         :label="$t('msg.총당첨슬')"  prop="tt11" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt11)}}</template>
      </el-table-column>
     


        <el-table-column
       :label="$t('msg.총수수료')" prop="tt678" align="center">
         <template slot-scope="scope"> <span class="text-warning">{{ formatMoney(scope.row.tt678)}}</span></template>
      </el-table-column>

      <el-table-column
       :label="$t('msg.총수수료카')" prop="tt7" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7)}}</template>
      </el-table-column>
      <el-table-column
       :label="$t('msg.총수수료슬')" prop="tt6" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6)}}</template>
      </el-table-column>
    

      <el-table-column
       :label="$t('msg.총정산금')" prop="zs_all" align="center">
         <template slot-scope="scope"> <span class="text-warning">{{ formatMoney(scope.row.zs_all)}}</span></template>
      </el-table-column>

      <el-table-column
       :label="$t('msg.정산금카')" prop="zs_ca" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.zs_ca)}}</template>
      </el-table-column>
      <el-table-column
       :label="$t('msg.정산금슬')" prop="zs_st" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.zs_st)}}</template>
      </el-table-column>
     

     

        
	
		 
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
				
				
</div>
 </template>

 <script>
  import calculation from '../../components/common/calculation.vue';
    export default {
       components: {
            calculation
    },
    	data(){
    		return{

           admin_id:'',
    			domain:window.sessionStorage.getItem('domain'),
          power:window.sessionStorage.getItem('power'),
        userid:window.sessionStorage.getItem('userid'),
    			  qa:[],
    			   colorObj:{
			        '0':'text-danger',
			        '1':'text-primary',
			        '2':'text-success',
			       
			       
			      },
    		
    			searchform:{
    				
    				keyword:'',
            time:[],
            searchOptions:[
             
             {
             label:this.$i18n.t("msg.부본사"),
              value:'b_code'
            },
             {
             label:this.$i18n.t("msg.총판"),
              value:'a_code'
            },
             {
             label:this.$i18n.t("msg.매장"),
              value:'c_code'
            }
            ],
           
            value:'',
    			


    			},
           adminlist:[{
                 label:this.$i18n.t("status.선택"),
                value:''
            },
            
            ],
    			 pickerOptions: {
    			},
         shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
     
		        
    		
    			total:0,
    			size:0,
    			loading: false,
    			 editIndex:-1,
    			 creatModel:false,
    			 tableData: [],
    			
			          currentPage:1,
			          multipleSelection:[],
			       
			         
    			}
    			
    			
    		},
    		created() {
          let token=window.sessionStorage.getItem('user');

           if(this.userid=="admin")
           {
               this.$axios({
                  method:'get',
                  url:this.domain+'/user/bubonlist_select?type=bossnull&admin=1',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
                }).then((response) =>{ 
                  
               let newids=[];

                let obj={};
                obj.label=this.$i18n.t("msg.없음")
                obj.value=''
                newids.push(obj); 

                newids=[];

                


                response.data.admin.forEach(item=>{
                let obj={};
                obj.label=item.name
                obj.value=item.name
                newids.push(obj);            
               });


               

               this.adminlist=newids
        
                }).catch((error) =>{
                  
                })
           }
          

       

    			this.getList();
    			
			
		},
    	
    	methods:{
    	openCal(id,type){

        if(type=='회원')
        {
           return;
        }
           
          this.$layer.iframe({
            type: 2,
            title: id,

            content: {
                content: calculation,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id',
                time:this.searchform.time
                }
              
            },
            
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['1200px','500px'],
            
         
        });
        },
        adminChange(v){
          //console.log(v)
          this.admin_id=v
          this.getList()
        },
    			 // 搜索事件
			searchEvent(){

    			this.getList();
    			
             

    		},
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			       getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if(index === 0){
             sums[index] = this.$i18n.t("msg.합계");
          }
         else if (index === 1) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 2) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 3) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 4) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 5) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 6) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 7) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 8) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 9) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 10) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 11) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 12) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 13) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 14) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 15) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 16) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 17) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 18) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 19) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 20) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            } else {
              sums[index] = '/';
            }
          }
        });
        return sums;
      },
     

    		getList(){

    		 
               //console.log(this.searchform.time) 
               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/user/calculation_mem?s_time='+s_time+'&e_time='+e_time+'&page='+this.currentPage+'&'+this.searchform.value+'='+this.searchform.keyword;
    			
    
    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 

              this.loading =false

                 if(response.data.code!=200)
                 {
                    this.$message.error(response.data.msg);
                    return;
                 }

                     //console.log('data=',response.data.data)
                     this.tableData =response.data.data
                     this.total = response.data.total
                     this.currentPage = response.data.current_page
                     this.size =response.data.per_page
                     
               
            }).catch((error) =>{
            	

               this.$message.error(error);
               this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    		
    		
    	
    	
    	
    		
    	}
  }
</script>

 <style scoped>
 .bg-danger{
 	background-color:#72e8ff!important
 }
.bg-primary{
	background-color:#acc4dd!important
}
.bg-yellow {
    background-color: #dc8e35!important;
}
/deep/ .el-select-dropdown__item.selected{
	color:#000
}
/deep/ .el-input__inner{
	background:transparent;
	border:1px solid #cfcfcf;
	border-radius:2px;
}
/deep/ .el-dialog__body{
	padding:10px 20px;
}
/deep/ .el-form-item {
	margin-bottom:10px;
}
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }

/deep/ .has-gutter tr td:nth-of-type(6) .cell,
 /deep/ .has-gutter tr td:nth-of-type(9) .cell,
 /deep/ .has-gutter tr td:nth-of-type(12) .cell,
 /deep/ .has-gutter tr td:nth-of-type(15) .cell {
  text-align: center;
  font-weight: bold;
  color: #ffc107 !important;
}


</style>


// WEBPACK FOOTER //
// src/views/calculation_new/list.vue